import IRepresentativeRepository from 'domain/interfaces/repositories/IRepresentativeRepository'
import { ReadRepresentativeAndStudentsQueryRequest } from 'domain/entities/representative'

export const readRepresentativeAndStudentsQuery = (
  repository: IRepresentativeRepository,
  params: ReadRepresentativeAndStudentsQueryRequest,
) => {
  return repository.getRepresentativeAndStudentsById(params)
}
